@let isLoading = schemaFeature.selectors.isLoading.asSignal();

@if (hasDimensionsSg()) {
  <div
    class="schema-graph"
    #graph
  ></div>
} @else if (isLoading) {
  <atn-ds-loader />
} @else {
  <div class="schema-graph__empty-state-container">
    <div class="schema-graph__empty-state-content">
      <atn-ds-empty-state
        type="no-data"
        title="Nothing to see here!"
        description="No data was found. Not what you expected? Try refreshing, check your source data, or contact support."
        (action)="refreshSchema()"
      ></atn-ds-empty-state>
    </div>
  </div>
}
